export default __webpack_public_path__ + "static/media/ikea.88d792d5.png";